"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PhoneNumberForm_1 = __importDefault(require("@App/kit/fields/v2/PhoneNumberForm"));
const FormFieldFromProps_1 = __importDefault(require("@App/kit/fields/v2/FormFieldFromProps"));
const react_1 = __importDefault(require("react"));
const ContactInfoSection = (props) => {
    const { phoneNumberForm, email, disableEmail } = props;
    return (react_1.default.createElement("section", { className: 'contact-info-section' },
        react_1.default.createElement("h5", null, "Contact Information"),
        react_1.default.createElement("div", { className: 'fields-row-container' },
            react_1.default.createElement(PhoneNumberForm_1.default, { phoneNumberFormFields: phoneNumberForm }),
            react_1.default.createElement(FormFieldFromProps_1.default, { field: email, isDisabled: disableEmail }))));
};
exports.default = ContactInfoSection;
